// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"ff7e954c","605":"c514be14","753":"17c21a8d","981":"3129e318"}[chunkId] + ".chunk.js";
};